import svgPaths from './svg-score';

interface ScoreChipProps {
  score: number;
}

const ScoreChip: React.FC<ScoreChipProps> = ({ score }) => {
  return (
    <div className="score-chip">
      <span className="score-chip__value">{score}</span>
      <span className="score-chip__icon" aria-hidden="true">
        <svg className="score-chip__ring" viewBox="0 0 35 35" fill="none" preserveAspectRatio="none">
          <circle cx="17.5" cy="17.5" r="17" stroke="var(--score-ring, #ffcc33)" />
        </svg>
        <svg className="score-chip__star" viewBox="0 0 30 27" fill="none" preserveAspectRatio="none">
          <path d={svgPaths.pdd58e30} fill="var(--score-star, #ffcc33)" />
        </svg>
      </span>
    </div>
  );
};

export default ScoreChip;
